import * as React from 'react';
export const MGSvg = React.forwardRef(function MGSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M1.998 2A2.005 2.005 0 0 0 0 4.009v7.982C0 13.101.898 14 1.998 14H6V2H1.998Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4v1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4v1H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M14.14 2C15.167 2 16 3.02 16 4.276V8H6V2h8.14Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M16 12.257c0 .961-.832 1.743-1.86 1.743H6V8h10v4.257Z',
      }),
    ),
  );
});
MGSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MG = {
  category: 'flag',
  colorable: false,
  name: 'MG',
  svg: MGSvg,
};
